import { api, apiUrl } from "../../shared/services/service";
import {
  AdminCertificatesSettingsListResponse,
  AdminCertificatesSettingsMutationResponse,
  AdminCertificatesSettingsPayload,
} from "../models/admin-certificates-settings.models";
import axios from "axios";

export const getAdminCertificatesSettings = async (): Promise<AdminCertificatesSettingsListResponse> => {
  const response = await api.get(`${apiUrl}/admin/certificates-settings`);
  return response.data;
};

export const updateAdminCertificatesSettings = async (
  id: number,
  settings: AdminCertificatesSettingsPayload,
): Promise<AdminCertificatesSettingsMutationResponse> => {
  const response = await api.post(`${apiUrl}/admin/certificates-settings/${encodeURIComponent(id)}/update`, {
    settings,
  });
  return response.data;
};

export const getAdminCertificatesSettingsErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Certificates settings request failed.";
};
